<template>
    <div id="app">
        <!-- 首屏展示区 -->
        <div class="home-screen">
            <div class="bg-home-screen" ref="bg"></div>
            <!-- 顶部菜单 -->
            <home-header />

            <!-- 中部搜索区域 -->
            <div class="home-screen-body">
                <h1 class="h1">
                    Book the
                    <img src="../../assets/best.png" class="best-ebbly" /> for Your Trip
                </h1>

                <!-- 搜索 -->
                <home-search />
            </div>
        </div>

        <!-- 首页推荐内容 -->
        <div class="home-body">
            <!-- 代预订模块 -->
            <div ref="pending">
                <hotel-block v-for="(item, index) in pendingData" :key="index" v-bind="item"></hotel-block>
            </div>
            <!-- 推荐广告栏 -->
            <home-banner />

            <!-- 特价精选 -->
            <top-deals />

            <!-- 推荐城市 -->
            <rec-city />

            <!-- 关于ebbly -->
            <ebbly-info />
        </div>

        <home-footer />

        <!-- 登录注册 -->
        <sign-up />
        <home-login />
        <home-forget />
    </div>
</template>

<script>
import HomeHeader from "./components/Header.vue";
import HomeSearch from "../Public/Search.vue";
import HomeBanner from "./components/Banner.vue";
import TopDeals from "./components/TopDeals.vue";
import RecCity from "./components/RecCity.vue";
import EbblyInfo from "./components/EbblyInfo.vue";
import HomeFooter from "./components/Footer.vue";
import HomeLogin from "@/views/Public/Login";
import HomeForget from "@/views/Public/Forget";
import SignUp from "@/views/Public/SignUp/Index";
import HotelBlock from "@/views/Public/components/HotelBlock.vue";
import { mapGetters } from "vuex";
import { linkTo } from "@/lib/utils";
import moment from "moment";

export default {
    name: "Home",
    components: {
        HomeHeader,
        HomeSearch,
        HomeBanner,
        TopDeals,
        RecCity,
        EbblyInfo,
        HomeFooter,
        HomeLogin,
        HomeForget,
        SignUp,
        HotelBlock
    },
    computed: {
        ...mapGetters(["token", "user", "area", "unit"])
    },
    data() {
        return {
            pendingData: [] //代预订数据
        };
    },
    watch: {
        //当登录状态变动时
        token: {
            handler: function(val) {
                //触发代预订查询
                this.getPendingOrder();

                //无值的情况不需要往下执行
                if (!val) {
                    return;
                }

                //触发国籍/地区修改
                let areaCode = this.user.user_info.extend.country_short_name;
                if (areaCode) {
                    this.$store.dispatch("updateCountry", areaCode);
                }
            }
        }
    },
    created() {
        this.$store.dispatch("updateHotelRate", this.unit);
    },
    mounted() {
        //是否已经登录
        if (this.token && this.user.user_info.extend.country_short_name) {
            let country = this.user.user_info.extend.country_short_name;
            /* 账户已经登录且有录入国家/地区 */
            this.$store.dispatch("updateCountry", country);
        } else if (!this.area || this.area === "US") {
            /* 没有则尝试获取地理位置 */
            this.getGeolocaion();
        }

        //代预订检测
        this.getPendingOrder();

        this.preloadImg(
            "https://g1.ifreegroup.co/ebbly/20190729/a7cae56626f2efd2f71ccf9ffd089651.png"
        );
    },
    methods: {
        /**
         * 预加载图片
         * @param {String} url 图片地址
         */
        preloadImg(url) {
            let bg = this.$refs.bg;
            let img = new Image();
            img.src = url;

            if (img.complete) {
                //本地有缓存的情况
                bg.style.backgroundImage = `url(${url})`;
                bg.style.filter = "none";
            } else {
                img.onload = function() {
                    bg.style.backgroundImage = `url(${url})`;
                    bg.style.filter = "none";
                };
            }
        },

        /**
         * 获取地理位置处理
         */
        getGeolocaion() {
            if ("geolocation" in navigator) {
                /* 地理位置可用 */
                let me = this;
                navigator.geolocation.getCurrentPosition(
                    function(position) {
                        console.info(position);
                        if (!me.area || me.area === "US") {
                            //允许获取
                            me.getCountryCode(
                                position.coords.latitude,
                                position.coords.longitude
                            );
                        }
                    },
                    function(error) {
                        console.info("defeat");
                        if (!me.area || me.area === "US") {
                            me.$store.dispatch("updateCountry", null);
                        }
                    }
                );
            } else {
                /* 地理位置不可用 */
                this.$store.dispatch("updateCountry", null);
            }
        },

        /**
         * 获取国家iso码
         * @param {String} lat 纬度
         * @param {String} lng 经度
         */
        getCountryCode(lat, lng) {
            console.info("get");
            this.$req
                .get("v1_8_3/getCountryCode", {
                    lat,
                    lng
                })
                .then(({ data }) => {
                    if (data.code === "2000") {
                        //缓存vuex
                        this.$store.dispatch(
                            "updateCountry",
                            data.data.country_code
                        );

                        //缓存定位国家/地区code
                        this.$local.set("gis.area", data.data.country_code);
                    } else {
                        this.$store.dispatch("updateCountry", null);
                    }
                });
        },

        /**
         * 获取代预订数据
         */
        getPendingOrder() {
            if (!this.token) {
                /* 如果未登录情况则不加载待支付订单 */
                return;
            }
            this.$req.post("v1_8/pendingOrders").then(({ data }) => {
                if (data.code === "2000") {
                    this.pendingData = data.data;
                    if (data.data && data.data.length > 0) {
                        this.pendingLinkTo(data.data);
                    }
                }
            });
        },

        /**
         * 跳转
         */
        pendingLinkTo(data) {
            this.$confirm(this.$t("to_be_pay"), {
                confirmButtonText: this.$t("continue"),
                cancelButtonText: this.$t("cancel")
            })
                .then(() => {
                    if (data.length > 1) {
                        //大于两单则滚动至代预订列表
                        scrollTo(0, this.$refs.pending.offsetTop);
                    } else {
                        this.$local.set("pending.data", {
                            check_in: moment(data[0].start_time * 1000).format(
                                "YYYY-MM-DD HH:mm"
                            ),
                            check_out: moment(data[0].end_time * 1000).format(
                                "YYYY-MM-DD HH:mm"
                            ),
                            roomName: data[0].room_type,
                            hotel_name: data[0].hotel_name,
                            room_count: data[0].room_count,
                            dur: data[0].dur
                        });
                        //否则直接跳转支付
                        linkTo(
                            `/payment?type=order&price=${data[0].amount}&currency=${data[0].currency}&order_sn=${data[0].order_sn}`
                        );
                    }
                })
                .catch(() => {});
        }
    }
};
</script>

<style lang="scss" scoped>
#app {
    background-color: #f9f9f9;
}
.home-screen-body,
.home-body {
    width: 1140px;
    margin: 0 auto;
}

.home-body {
    padding: 80px 0;
}

.home-screen {
    position: relative;
    // display: flex;
    // flex-direction: column;
    width: 100%;
    height: 800px;

    .bg-home-screen {
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        overflow: hidden;
        background-image: url("../../assets/home-bg.jpg");
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
        filter: blur(10px);
    }

    @media screen and (max-width: 1367px) {
        height: 100vh;
    }

    .home-screen-body {
        position: absolute;
        left: 50%;
        top: 80px;
        z-index: 1;
        transform: translateX(-50%);
        height: calc(800px - 80px);
        @media screen and (max-width: 1367px) {
            height: calc(100vh - 80px);
        }
        display: flex;
        flex-direction: column;
        justify-content: center;

        .h1 {
            margin: 0;
            padding-bottom: 25px;
            font-size: 54px;
            color: #fff;

            .best-ebbly {
                height: 54px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/home/Home.vue